import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    if (window.innerWidth > 992) {
        document.querySelectorAll('header [paws-component="noss-nav"][paws-template="default"] .nav-item.dropdown').forEach(function(everyitem){
            everyitem.addEventListener('mouseover', function(e){
                let el_link = this.querySelector('a[data-bs-toggle]');
                if(el_link != null){
                    if (!el_link.classList.contains('show')) {
                        el_link.click();
                    }
                }
            });
            everyitem.addEventListener('mouseleave', function(e){
                let el_link = this.querySelector('a[data-bs-toggle]');
                if(el_link != null){
                    if (el_link.classList.contains('show')) {
                        el_link.click();
                    }
                }
            })
        });
    }
}